








































































import Vue from 'vue';
import { mapActions } from 'vuex';
import { get } from 'vuex-pathify';
import moment from 'moment';

import ErrorAlert from '../common/ErrorAlert.vue';
import ALDialog from '../core/Dialog/ALDialog.vue';
import EmployeeFormSubmissionStatusDisplay from './EmployeeFormSubmissionStatusDisplay.vue';

import { Transition } from '@/models/transition';
import { ErrorManager } from '@/models/error';
import { EmployeeFormSubmission, IEmployeeFormSubmission } from '@/models';

export default Vue.extend({
  components: { ErrorAlert, EmployeeFormSubmissionStatusDisplay, ALDialog },
  data: () => ({
    dialog: false,
    loading: false,

    errorMessage: '',
    detailErrorMessage: '',

    employeeeFormSubmission: {} as IEmployeeFormSubmission,

    headers: [
      {
        text: 'Date',
        align: 'start',
        sortable: false,
        value: 'timestamp'
      },
      {
        text: 'Changed By',
        align: 'center',
        sortable: false,
        value: 'user'
      },
      {
        text: 'Previous State',
        align: 'center',
        sortable: false,
        value: 'source_state'
      },
      {
        text: 'Current State',
        align: 'center',
        sortable: false,
        value: 'state'
      }
    ]
  }),

  computed: {
    employeeFormSubmissionActivities: get<Transition[]>(
      'employeeForm/getEmployeeFormSubmissionActivities'
    ),

    EmployeeFormSubmission: () => EmployeeFormSubmission
  },

  methods: {
    moment,

    ...mapActions({
      fetchEmployeeFormSubmissionActivities:
        'employeeForm/fetchEmployeeFormSubmissionActivities'
    }),

    clearAllErrors(): void {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    },

    open(employeeFormSubmission: IEmployeeFormSubmission) {
      this.clearAllErrors();

      this.employeeeFormSubmission = employeeFormSubmission;

      this.dialog = true;
      this.loading = true;

      this.fetchEmployeeFormSubmissionActivities(employeeFormSubmission.id)
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.detailErrorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    close() {
      this.dialog = false;
    }
  }
});
